import { ordinal } from "./format";

/**
 * The text of the milestone notes written to the Zoho lead (Asana 1219442712187460,
 * Miles 2026-10-25): each milestone carries "all other notes that were typed on
 * that screen". One labelled line per non-empty field.
 */

const notesOf = (job) => (job && job.s2Notes && !Array.isArray(job.s2Notes) ? job.s2Notes : {});

const lines = (pairs) =>
  pairs
    .map(([label, value]) => [label, String(value == null ? "" : value).trim()])
    .filter(([, value]) => value !== "")
    .map(([label, value]) => `${label}: ${value}`)
    .join("\n");

/** "CC – 2nd confirmation call attempt" etc., per screen. */
export const attemptLabel = (screen, n) => {
  const nth = ordinal(n);
  if (screen === "confirm") return `CC – ${nth} confirmation call attempt`;
  if (screen === "post-move") return `ADF – ${nth} post-move call attempt`;
  return `Introduction call – ${nth} attempt`;
};

/** MIP / APF: what the MC typed on the In Progress screen, plus the escalations raised on the job. */
export const inProgressNotesText = (job, escalations = []) => {
  const n = notesOf(job);
  const esc = (escalations || [])
    .filter((e) => e && e.jobId === job.id)
    .map((e) => `[${e.type}${e.status === "resolved" ? ", resolved" : ""}] ${e.note}`)
    .join("; ");
  return lines([
    ["Feedback from the client", job.inProgressFeedback],
    ["Logistics notes", n.logisticsNotes],
    ["Dispatched crew (MC note)", n.dispatchedCrew],
    ["Escalations", esc],
    ["Post escalation notes", job.postEscalationNotes],
  ]);
};

/** ADF: what the MC typed on the Post Move screen. */
export const postMoveNotesText = (job) => {
  const n = notesOf(job);
  const attempts = Array.isArray(job.postMoveAttempts) ? job.postMoveAttempts.length : 0;
  const issues = (Array.isArray(job.pmIssues) ? job.pmIssues : [])
    .map((i) => `${i.text} (${i.status === "resolved" ? "resolved" : "open"})`)
    .join("; ");
  const fb = job.pmFeedback || {};
  const list = (v) => (Array.isArray(v) ? v.join(", ") : "");
  return lines([
    ["Actual delivery date", job.actualDeliveryDate],
    ["The crew", fb.crew],
    ["Care of belongings", fb.care],
    ["Sales & communication", fb.sales],
    ["What stood out", list(fb.liked)],
    ["What could we do better", list(fb.improve)],
    ["Would recommend us", fb.recommend],
    ["The feedback from the client", n.pmClientQuote],
    ["Post-move call attempts", attempts ? String(attempts) : ""],
    ["Feedback for the crew", n.feedbackOperations],
    ["Crew feedback for the salesperson", n.crewFeedbackSalesperson],
    ["Notes", n.postMoveNotes],
    ["Price adjustments", n.priceAdjustments],
    ["Notes for the automated flow", n.automatedFlowNotes],
    ["Post-move issues", issues],
  ]);
};
